<template>
  <div>
    <v-container fluid grid-list-md>
      <v-app id="inspire">

        <NewEditagency style="float:left" v-on:create="create($event)">
          <template v-slot:activator="{on}">
            <v-btn v-on="on">{{ $t('department.new') }}</v-btn>
          </template>
        </NewEditagency>

        <v-data-table :headers=" headers" :items="agencies" class="elevation-10">
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.description }}</td>
            <td>
              <NewEditagency :agency="props.item" style="float:left" v-on:update="update($event)"/>
              <v-btn icon small>
                <v-icon block fab small @click="deleteAgency(props.item.id)">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>

      </v-app>
    </v-container>
  </div>
</template>
<script>
import NewEditagency from './NewEdit'
import Messenger from "@/plugins/Messenger"

export default {
  components: {
    NewEditagency
  },
  data() {
    return {
      name: "",
      active: false,
      agencies: [],
      headers: [{
        text: 'ID',
        value: "id",
      },
      {
        text: this.$t('archive.name'),
        value: 'name'
      },
      {
        text: this.$t('department.description '),
        value: 'description'
      },
      {
        text: this.$t('department.actions'),
      }
      ]
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {
    this.loadAgencies()
  },
  methods: {
    update(agency) {
      this.$http.put('agency/' + agency.id, agency).then(() => {
        let modelToUpdate = this.agencies.find(el => el.id == agency.id)
        modelToUpdate.description = agency.description
        modelToUpdate.name = agency.name
      })
        .catch(() => Messenger.emitError("Bład"))
    },
    create(agency) {
      this.$http.post('agency', agency).then(data => {
        this.agencies.push(data.data)
      }).catch(() => Messenger.emitError("Bład"))
    },
    loadAgencies() {
      this.$http.get('agencies').then(data => {
        this.agencies = data.data
      }).catch(() => Messenger.emitError("Bład"))
    },
    deleteAgency(id) {
      this.$confirm(this.$t('related.delete_confirmation'))
        .then(res => {
          if (res) {
            this.$http.delete("agency/" + id).then(() => {
              this.agencies = this.agencies.filter(el => el.id != id)
            }).catch(() => Messenger.emitError("Bład"))
          }
        })
    },
  },
}
</script>

<style>

</style>
